import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=0a61415c&scoped=true&"
import script from "./order_list.vue?vue&type=script&lang=js&"
export * from "./order_list.vue?vue&type=script&lang=js&"
import style0 from "./order_list.vue?vue&type=style&index=0&id=0a61415c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a61415c",
  null
  
)

export default component.exports